import { defineComponent as _defineComponent } from 'vue'
import { ref,onMounted, onUnmounted, watch ,} from "vue-demi";
import TUIRoomCore,{ETUIRoomEvents, RoomInfo} from "@/TUIRoom/tui-room-core";
import { useBasicStore } from '@/stores/basic';
import { storeToRefs } from 'pinia';

interface Props {
  voteActivity: any,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'resuliList',
  props: {
    voteActivity: null
  },
  setup(__props: any) {

const props = __props as {
  voteActivity: any,
}

const basicStore = useBasicStore();
const { votemsgContent }= storeToRefs(basicStore);






const sum=ref({})


watch(votemsgContent,(val)=>{
    props.voteActivity=val
})







const setItemText=(j)=>{
   console.log(j.answerItem);
   return j.answerItem
}




return { __sfc: true,basicStore, votemsgContent, props, sum, setItemText }
}

})